var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c(
      "button",
      {
        staticClass: "dropdown-item",
        attrs: {
          type: "button",
          "data-bs-toggle": "offcanvas",
          "data-bs-target": "#userProfileOffcanvas",
        },
      },
      [
        _c("i", { staticClass: "me-2 bi bi-person" }),
        _vm._v("\n    User profile\n"),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }